import {statusFlags} from './statusFlags'

export const getLastStatus = (clientStatuses) => {
  const getColor = (state) => {
    switch (state) {
    case 'in_progress':
      return 'bg-yellow-200'
    case 'completed':
      return 'bg-green-200'
    case 'canceled':
      return 'bg-red-200'
    default:
      return 'bg-gray-200'
    }
  }
  if(!clientStatuses.length) {
    return {
      name: 'Nicht verarbeitet',
      color: 'bg-gray-200',
    }
  }
  const steps = [...clientStatuses]
  // Sort descending by updated_at
  steps.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))

  // Get the most recently updated one
  const latestStep = steps[0]
  return {
    name: statusFlags.find((steps) => steps.key === latestStep.name).value,
    color: getColor(latestStep.state),
  }
}

export const convertStatusesToArray = (statuses) => {
  return Object.entries(statuses).map(([key, value]) => ({
    key,
    value,
  }))
}
